import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { getCurrency, getTokens, setCurrentTrade } from '../redux/exchange/action'
import { getPeers } from '../redux/node/action'
import { getPairs } from '../redux/tradePairs/action'
import { getFees } from '../redux/fees/action'
import { getAccount } from '../redux/account/action'
import { getIpValidation } from '../redux/global/action'
import { fetchI18n } from '../i18n/reducer'

class CommonDataProvider extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    currentTrade: PropTypes.string,
    pairs: PropTypes.array,
  }

  static defaultProps = {
    dispatch: () => {},
    currentTrade: '',
    pairs: [],
  }

  componentDidMount() {
    const { dispatch } = this.props

    dispatch(getCurrency())
    dispatch(getPeers())
    dispatch(getFees())
    dispatch(getTokens())
    dispatch(getPairs())
    dispatch(getIpValidation())
    dispatch(fetchI18n())

    let user = sessionStorage.getItem('user')
    user = (user && JSON.parse(user)) || {}

    if (user.address) {
      dispatch(getAccount(user.address))
    }
  }

  componentDidUpdate() {
    this._setCurrentTrade()
  }

  _setCurrentTrade = () => {
    const { pairs, currentTrade, dispatch } = this.props
    if (!currentTrade && pairs.length > 0) {
      const defaultPair = pairs[0]
      const firstTrade = `${defaultPair.base_asset_symbol}_${defaultPair.quote_asset_symbol}`
      dispatch(setCurrentTrade(firstTrade))
    }
  }

  render() {
    return <Fragment>{null}</Fragment>
  }
}

const mapStateToProps = ({ exchange: { currentTrade }, tradePairs: { pairs } }) => ({
  currentTrade,
  pairs,
})

export default connect(mapStateToProps)(CommonDataProvider)
